import React from "react"
import humanizeDuration from "humanize-duration"

import GeneralCard from "../base"
import { BylineAuthor } from "../base/styles"
import { VideoDuration, BottomRightPlayIcon } from "./styles"

const VideoCard = ({ speakers, lengthInSeconds, ...props }) => (
  <GeneralCard
    topLeftElement={
      <VideoDuration>
        {humanizeDuration(lengthInSeconds * 1000, {
          units: ["h", "m"],
          delimiter: " ",
          round: true,
        })}
      </VideoDuration>
    }
    bylineElement={<BylineAuthor>{speakers?.join(", ")}</BylineAuthor>}
    bottomRightElement={<BottomRightPlayIcon />}
    {...props}
  />
)

export default VideoCard
